<template>
   <Forms ref="frmSearch"
           title="PESQUISAR REEMBOLSO VIAGEM"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClearSection"
           v-on:Search="Search"
           >
            <div class="form-group row">
          <label for="cbxInsure">Funcionário:</label>
          <autocomplete-z ref="favorecidoTypeahead"
                placeholder="Digite o nome do Funcionário"
                iconClass="fas fa-id-badge"
                :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
                :debounceLength="3"
                :formField="this.funcionarioId"
                v-on:search="onSearchFavorecido"
                v-on:changeCode="onChangeCodeFavorecido" />
            </div>
          <label for="cbxInsure">Número do Lote:</label>
          <b-input v-model="lote" placeholder="Insiro o Número do Lote" />
   </Forms>
</template>

<script>
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '../../mixins/ExpenseMixin'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
// import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm'
// import SectionRHRepository from '@/shared/http/repositories/business/sectionrh'
// import ExpenseRepository from '@/shared/http/repositories/business/expense'
// import { loading } from '@/shared/utils/UIHelper'
export default {
  name: 'ExpenseSearch',
  components: {AutocompleteZ},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      funcionarioId: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      lote: ''
    }
  },
  methods: {
    Search () {
      let data = {
        FuncionarioId: this.funcionarioId.value,
        Lote: this.lote
      }
      localStoreHelper.prestacaoContas.viagem(data)
      this.$emit('search', data)
    },
    onClearSection () {
      this.$refs.favorecidoTypeahead.clear()
      localStoreHelper.prestacaoContas.viagem(null)
      this.funcionarioId.value = ''
      this.lote = ''
    }

  }
}
</script>

<style>
.label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/finance/accountability/components/travelExpenseTab/components/travelexpensezpag/components/ExpenseSearch/ExpenseSearch.vue